import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async update ({ state, dispatch }) {
    try {
      const data = {
        now: state.now,
        memo: state.memo
      }

      await directus.updateItem('member_seating_status', state.id, data)
      return true
    } catch (err) {
      errorDirectus(err, dispatch)
      return false
    }
  }
}
